import App from '@/app/App';
import withAnalytics from '@/app/analytics/withAnalytics';
import withMeetingQuery from '@/app/queries/MeetingQuery/withMeetingQuery';

// Only what the lobby itself needs lives here; everything the call needs —
// the Agora client and the in-call providers — mounts lazily from
// CallExperience the moment the customer joins.
const ConnectedApp = withAnalytics(withMeetingQuery(App));

export default ConnectedApp;
